import { render, staticRenderFns } from "./CRMRelationshipForm.vue?vue&type=template&id=6dbeebe0"
import script from "./CRMRelationshipForm.vue?vue&type=script&lang=js"
export * from "./CRMRelationshipForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports